export default __webpack_public_path__ + "static/media/raniasaied2.20b89107.png";